const TempBanner = () => (
  <div
    className="tempBanner"
    role="img"
    aria-label="NAFDAK — Trade Forex. Move the World."
    style={{
      "--banner-url": `url(${process.env.PUBLIC_URL}/nafdak-banner-2.png)`,
    }}
  />
);

export default TempBanner;
